import React, { useContext, useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import styles from "./components.module.scss";
import { AppData } from "../../../context/context";
import { Link } from "react-router-dom";

const Footer = ({
  uniqueKey = "",
  isLoading,
  button1 = "",
  button2 = "",
  linkButton1 = "/",
  handleSaveBtn,
  isDisabled = false,
}) => {
  const { formMode, setFormMode, setJobConfigMode, jobConfigMode } =
    useContext(AppData);

  /* Other states */

  const [mode, setMode] = useState("");

  /* UseEffects */

  useEffect(() => {
    if (uniqueKey === "jobConfig") {
      setMode(jobConfigMode);
    } else {
      setMode(formMode);
    }
  }, [uniqueKey, jobConfigMode, formMode]);

  return (
    <Grid item xs={12} className={`${styles.saveCancel}`}>
      {isLoading && <span style={{ marginRight: "21px" }}>Please wait...</span>}
      <Link to={linkButton1} style={{ textDecoration: "none" }}>
        <Button
          onClick={() => {
            uniqueKey === "jobConfig"
              ? setJobConfigMode("create")
              : setFormMode("create");
          }}
          variant="outlined"
        >
          {button1}
        </Button>
      </Link>
      <Button onClick={handleSaveBtn} variant="contained" disabled={isDisabled}>
        {button2}
      </Button>
    </Grid>
  );
};

export default Footer;
